module.exports = __webpack_public_path__ + "static/media/itemSvg.ea89b0cb.svg";